import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { environment } from '../environments/environment';

// Swiper Slider
// bootstrap component
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ToastrModule } from 'ngx-toastr';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';


// Store
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
// Page Route
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Auth
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FilemanagerEffects } from './store/filemanager/filemanager.effects';
import { rootReducer } from './store';


import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';

// Formly Module
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
// import { RangeTypeComponent } from './range-type.component';
import { RangeTypeComponent } from './range-type.component';

import { HighchartsChartModule } from 'highcharts-angular';



export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    RangeTypeComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LayoutsModule,
    AppRoutingModule,
    AccordionModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    ScrollToModule.forRoot(),
    ToastrModule.forRoot({
      preventDuplicates: true, // prevents duplicate toastrs
      maxOpened: 1, // limits the number of toastrs opened at the same time
      autoDismiss: true, // automatically dismisses old toastrs when new ones are shown
      timeOut: 2000,
    }// sets the
    ),
    BsDropdownModule.forRoot(),
    StoreModule.forRoot(rootReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    EffectsModule.forRoot([
      FilemanagerEffects,
    ]),
    ModalModule.forChild(),
    FormlyModule.forRoot({
      types: [{ name: 'range', component: RangeTypeComponent }]
    }),
    FormlyBootstrapModule,
    HighchartsChartModule
  ],
  bootstrap: [AppComponent],
  providers: [
  ],
})
export class AppModule { }
